import { io } from "socket.io-client";

class SocketService {
  socket = null;

  connect(token) {
    if (this.socket) return this.socket;

    // Connect to host (using window.location.origin fallback or direct backend URL)
    let socketUrl = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL || "https://iptestapi.irbureau.com";
    if (socketUrl.endsWith("/")) {
      socketUrl = socketUrl.slice(0, -1);
    }
    
    this.socket = io(socketUrl, {
      auth: {
        token: token
      },
      transports: ["polling", "websocket"]
    });

    this.socket.on("connect", () => {
      console.log("[SOCKET SERVICE] Successfully connected to WebSocket server:", this.socket.id);
    });

    this.socket.on("connect_error", (error) => {
      console.error("[SOCKET SERVICE] Connection error:", error.message);
    });

    return this.socket;
  }

  joinSurvey(surveyId) {
    if (this.socket) {
      this.socket.emit("joinSurvey", surveyId);
    }
  }

  leaveSurvey(surveyId) {
    if (this.socket) {
      this.socket.emit("leaveSurvey", surveyId);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

const socketService = new SocketService();
export default socketService;
